import {CONTENT_TYPE_TEXT, CONTENT_CATEGORY_CLIENT} from '../../constants';

export default {
  id: 'QUEST_MUTUAL',
  title: 'Mein Kunde ist kein OFA-Mitglied, kann er meine Datei abrufen?',
  description: '',
  categories: [CONTENT_CATEGORY_CLIENT],
  contents: [{
    type: CONTENT_TYPE_TEXT,
    value: 'Der Ziel der Plattform ist es, dass Sie Ihre Dokumente einmal hochladen können, damit Ihr gesamtes Netzwerk darauf zugreifen kann. Als Mitglied erlauben Sie Ihrem Netzwerk, kostenlos auf Ihre Dokumente zuzugreifen, auch wenn sie nicht auf OFA sind.'
  }]
};
